import { render } from "./404.vue?vue&type=template&id=5ece8d0b"
const script = {}

import exportComponent from "/var/www/pc-coupons/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__